import { useTranslation } from "react-i18next";
import classes from "./StatusTooltip.module.css";

export function FileStatusTooltip() {
  const { t } = useTranslation("imports");
  return (
    <dl className={classes.inlineDl}>
      <dt>{t("statusTooltip.file.unmapped")}</dt>
      <dd>{t("statusTooltip.file.unmappedDesc")}</dd>
      <dt>{t("statusTooltip.file.processing")}</dt>
      <dd>{t("statusTooltip.file.processingDesc")}</dd>
      <dt>{t("statusTooltip.file.mapped")}</dt>
      <dd>{t("statusTooltip.file.mappedDesc")}</dd>
      <dt>{t("statusTooltip.file.failed")}</dt>
      <dd>{t("statusTooltip.file.failedDesc")}</dd>
    </dl>
  );
}

export function ListingStatusTooltip() {
  const { t } = useTranslation("imports");
  return (
    <dl className={classes.inlineDl}>
      <dt>{t("statusTooltip.listing.original")}</dt>
      <dd>{t("statusTooltip.listing.originalDesc")}</dd>
      <dt>{t("statusTooltip.listing.mapped")}</dt>
      <dd>{t("statusTooltip.listing.mappedDesc")}</dd>
      <dt>{t("statusTooltip.listing.edited")}</dt>
      <dd>{t("statusTooltip.listing.editedDesc")}</dd>
    </dl>
  );
}
